import React, { useState, useEffect } from 'react';
import { getDevelopmentById } from '../../context/Auth'; // Asumiendo que esta función ya está definida

const NemuContext = React.createContext();

function NemuProvider(props) {
  const [selectedProp, setSelectedProp] = useState(0); // Estado para la propiedad seleccionada
  const [project, setProject] = useState(null); // Estado para almacenar el proyecto obtenido de la API

  // Consulta la API cada vez que `selectedProp` cambie
  useEffect(() => {
    if (selectedProp === 0) return; // Si no hay `selectedProp`, no hace la consulta

    // Llamamos a la API con `selectedProp` (el ID seleccionado)
    getDevelopmentById(selectedProp)
      .then(data => {
        // Mapeamos los datos para ajustarlos a tu formato esperado
        const mappedProject = {
          id: data.id,
          text: 'Falta por definir',  // Mantienes "Falta por definir"
          title: data.name,  // Usamos el nombre del proyecto de la API
          location: data.address,  // Dirección del proyecto
          date: data.delivery_date,  // Fecha de entrega
          private: data.is_private,  // Información sobre la privacidad
        };
        setProject(mappedProject); // Actualizamos el estado con el proyecto mapeado
      })
      .catch(error => console.error('Error al obtener el proyecto:', error));
  }, [selectedProp]); // Solo ejecuta la consulta cuando `selectedProp` cambie

  return (
    <NemuContext.Provider value={{
      selectedProp,
      setSelectedProp,
      project,  // Pasamos el proyecto obtenido
    }}>
      {props.children}
    </NemuContext.Provider>
  );
}

export { NemuProvider, NemuContext };
